import { apiRequestWithRetry } from 'src/common/utils/apiFetch';
import captureException from 'src/common/utils/captureException';
import { TripCartSeasonData } from 'src/listing/types';

/**
 * Get the season duration for a given date
 * @param listingId - listing id
 * @param date - formatted date string (YYYY-MM-DD)
 * @returns TripCartSeasonPriceSet for the date
 */
const getSeasonPriceSetsForDate = async (
  listingId: string,
  date: string,
): Promise<TripCartSeasonData | null> => {
  let seasonData: TripCartSeasonData | null = null;
  const searchParams = new URLSearchParams({ date });
  const url = `/api/prices/v1/${listingId}/durations?${searchParams.toString()}`;
  try {
    const response = await apiRequestWithRetry({
      uri: url,
      fallback: async () => {
        captureException('Failed to fetch seasons for the listing');
        return null;
      },
    });

    if (response?.status === 200) {
      seasonData = await response.json();
    }
  } catch (error) {
    captureException(error);
  }
  return seasonData;
};

export default getSeasonPriceSetsForDate;
